import { useRef } from "react";
import classes from "./TaskForm.module.css";

const TaskForm = (props) => {
  const taakInputRef = useRef();
  const statusInputRef = useRef();
  const begindatumInputRef = useRef();
  const einddatumInputRef = useRef();

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredTaak = taakInputRef.current.value;
    const enteredStatus = statusInputRef.current.value;
    const enteredBegindatum = begindatumInputRef.current.value;
    const enteredEinddatum = einddatumInputRef.current.value;

    const taakObj = {
      taak: enteredTaak,
      status: enteredStatus,
      begindatum: enteredBegindatum,
      einddatum: enteredEinddatum,
    };
    console.log(taakObj);

    if (enteredTaak.trim().length > 0) {
      props.onEnterTask(taakObj);
    }

    taakInputRef.current.value = null;
    statusInputRef.current.value = null;
    begindatumInputRef.current.value = null;
    einddatumInputRef.current.value = null;
  };

  return (
    <div className={classes.control}>
      <form className={classes.form} onSubmit={submitHandler}>
        <label htmlFor="taak">Taak</label>
        <input id="taak" ref={taakInputRef} type="text" />

        <label htmlFor="status">Status</label>
        <select name="status" id="status" ref={statusInputRef}>
          <option defaultValue="selected" value=""></option>
          <option value="Gepland">Gepland</option>
          <option value="Start">Start</option>
          <option value="Onderhanden">Onderhanden</option>
          <option value="Voltooid">Voltooid</option>
        </select>

        <label htmlFor="begindatum">Begindatum</label>
        <input id="begindatum" ref={begindatumInputRef} type="date" />

        <label htmlFor="einddatum">Einddatum</label>
        <input id="einddatum" ref={einddatumInputRef} type="date" />

        <button>{props.loading ? "Sending..." : "Toevoegen Taak"}</button>
      </form>
    </div>
  );
};

export default TaskForm;